import { createContext, useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { matchActivePath } from './matchActivePath';

// Every sidebar destination, provided by SideBar so an item can tell whether it
// is the best match for the current path (and not just a prefix of it).
export const ActivePathsContext = createContext(null);

export function ActivePathsProvider(props) {
    return (
        <ActivePathsContext.Provider value={props.paths}>
            {props.children}
        </ActivePathsContext.Provider>
    );
}

/**
 * props:
 * - to: /settings
 * - text: Settings
 * - children: tag icon
 */
function SideBarItem(props) {
    const { pathname } = useLocation();
    // Without a provider fall back to a single-path match.
    const paths = useContext(ActivePathsContext) || [props.to];
    const isActive = matchActivePath(pathname, paths) === props.to;

    return (
        <li className={isActive ? 'nav-item active' : 'nav-item'}>
            <Link to={props.to} className="nav-link" onClick={props.onClick}>
                <span className="sidebar-icon">{props.children}</span>
                <span className="sidebar-text">{props.text}</span>
            </Link>
        </li>
    );
}

export default SideBarItem;
